// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M8.00391 8.00391V6H6.00391V6.00391H6V8.00391H8.00391Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M8.00391 13.0039V11H6.00391V11.0039H6V13.0039H8.00391Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M8.00391 18.0039V16H6.00391V16.0039H6V18.0039H8.00391Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M12 2H2V22H17V16H22V10H12V2ZM10 4V20H4V4H10Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M22 18H19V22H22V18Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-city-1-filled')
export default class City1FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'city-1-filled',
    }
  }
}
